const LANDING_OPTIONS_MODAL_COMPONENT_TITLE_PROPS = {
  bold: true,
  showBuilder: false,
  testId: 'loading-title',
};

export { LANDING_OPTIONS_MODAL_COMPONENT_TITLE_PROPS };
